import { useMemo } from "react";
import { useGeneralPermissions, Result as GeneralResult } from "app/api/graph/hook/use-general-permissions";
import { ReportVulnerabilityAttribute } from "app/api/graph/security-attributes";

type Result = GeneralResult & {
    canTransition: boolean;
    canCreateAction: boolean;
    canCreateFile: boolean;
    canCreateClientNotification: boolean;
};

export const useReportVulnerabilityPermissions = (permissions: string[] | null | undefined): Result => {
    const generalResult = useGeneralPermissions(permissions);

    return useMemo(
        () => ({
            ...generalResult,
            canTransition: permissions?.includes(ReportVulnerabilityAttribute.Transition) ?? false,
            canCreateAction: permissions?.includes(ReportVulnerabilityAttribute.CreateAction) ?? false,
            canCreateFile: permissions?.includes(ReportVulnerabilityAttribute.CanCreateFile) ?? false,
            canCreateClientNotification:
                permissions?.includes(ReportVulnerabilityAttribute.CreateClientNotification) ?? false,
        }),
        [permissions],
    );
};
